var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.value,"vertical":"","timeout":"-1","color":"success"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-btn',{staticClass:"ml-2",on:{"click":_vm.handleExit}},[_vm._v(" Войти в личный кабинет ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }